var React = require('react');

function AboutPrinter (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M6.78601 0.193359H18.9381V3.22868H6.78601V0.193359Z","fill":"#EFEFEF","key":0}),React.createElement("path",{"d":"M23.497 4.75195H2.22811C1.39097 4.75195 0.710449 5.43787 0.710449 6.26961V13.8633C0.710449 14.7005 1.39637 15.381 2.22811 15.381H6.78649V21.457H18.9386V15.3864H23.497C24.3341 15.3864 25.0146 14.7005 25.0146 13.8687V6.26961C25.0146 5.43787 24.3287 4.75195 23.497 4.75195ZM3.74577 9.31034C2.90863 9.31034 2.22811 8.62982 2.22811 7.79268C2.22811 6.95553 2.90863 6.27501 3.74577 6.27501C4.58291 6.27501 5.26343 6.95553 5.26343 7.79268C5.26343 8.62982 4.58832 9.31034 3.74577 9.31034ZM17.4209 19.9448H8.30415V12.3457H17.4209V19.9448Z","fill":"#EFEFEF","key":1})]);
}

AboutPrinter.defaultProps = {"width":"26","height":"22","viewBox":"0 0 26 22","fill":"none"};

module.exports = AboutPrinter;

AboutPrinter.default = AboutPrinter;
